import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueuesLandingEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const queuesLandingEntryPoint: EntryPoint<QueuesLandingEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<QueuesLandingEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-queues-landing", jiraSpaEntry: "async-servicedesk-queues-landing-entrypoint" */ './ExportedDefault.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
